<template>
  <div>

    <v-row>
      <v-col cols='1'>
      </v-col>
      <v-col
        cols='5'
        v-if='donation'
      >
        <v-card
          class="mx-auto ma-5"
          elevation="2"
        >
          <v-card-title>
            <v-icon large>
              mdi-package-variant-closed
            </v-icon>
            Donation : {{this.$route.params.id}}
          </v-card-title>
          <v-card-text>

            <div class="my-4 subtitle-1">

              Lot Number : <strong>{{donation.lotNumber}}</strong>

            </div>

            <div class="my-4 subtitle-1">
              Donation created at : <strong>{{donation.time}} ({{dayElapsed(donation.time)}} days old)</strong>
            </div>
            <div class="my-4 subtitle-1">

              Are all devices functional and less than 7 years old? : <strong>{{donation.isFunctionalAnd7YearsOld}}</strong>

            </div>

            <div class="my-4 subtitle-1">

              Items to donate : <strong>{{donation.computerToDonate}}</strong>

            </div>
            <div class="my-4 subtitle-1">
              Description : <strong>{{donation.description}}</strong>
            </div>
          </v-card-text>
        </v-card>
        <v-card
          class="mx-auto ma-5"
          elevation="2"
        >
          <v-card-title>
            <v-icon large>
              mdi-hand-heart
            </v-icon>
            Donor Infomation
          </v-card-title>
          <v-card-text>
            <div class="my-4 subtitle-1">
              Name : <strong>{{donor.name}}</strong>
            </div>
            <div class="my-4 subtitle-1">
              Email : <strong>{{donor.email}}</strong>
            </div>
            <div class="my-4 subtitle-1">
              Address : <strong>{{donor.address}}</strong>
            </div>
            <div class="my-4 subtitle-1">
              City : <strong>{{donor.city}}</strong>
            </div>
            <div class="my-4 subtitle-1">
              State : <strong>{{donor.state}}</strong>
            </div>
            <div class="my-4 subtitle-1">
              Zip : <strong>{{donor.zip}}</strong>
            </div>
          </v-card-text>
        </v-card>
        <v-card
          class="mx-auto ma-5"
          elevation="2"
        >
          <v-card-title>
            Tracking # <a
              class='ml-3'
              :href='`https://wwwapps.ups.com/WebTracking/track?track=yes&trackNums=${donation.tracking}&requester=ST/trackdetails`'
              target='blank'
            >{{donation.tracking}}</a>

          </v-card-title>

        </v-card>
        <v-card
          class="mx-auto ma-5"
          elevation="2"
        >
          <v-card-title>
            Total value of this donation
          </v-card-title>
          <v-card-text>
            <div class="my-4 subtitle-1">
              <strong>${{donationPrice}}</strong>
            </div>
          </v-card-text>
        </v-card>
      </v-col>
      <v-col cols='6'>

        <v-card
          v-for='(item,index) in assets'
          :key='index'
          class="mx-auto ma-5"
          max-width="430"
          outlined
        >

          <v-list-item
            three-line
            @click='routeTo(item.assetTag)'
          >

            <v-list-item-content>

              <v-list-item-title class="headline mb-1">

                {{item.assetTag}} <a style='color:green'>(${{item.Value}})</a>

              </v-list-item-title>

            </v-list-item-content>

            <v-list-item-avatar size="80">

              <v-icon
                :color='itemColor(item)'
                x-large
              >

                {{Asseticon(item)}}

              </v-icon>

            </v-list-item-avatar>

          </v-list-item>

        </v-card>

      </v-col>

    </v-row>

  </div>
</template>

<script>
import moment from "moment";
const fb = require("../../firebaseconfig");
import { mapFields } from "vuex-map-fields";
export default {
  data() {
    return {
      donor: {
        name: null,
        id: null,
        address: null,
        city: null,
        email: null,
        ngo: null,
        state: null,
        zip: null,
      },
      donationPrice: 0,
      donation: null,
      assets: [],
    };
  },
  computed: {
    ...mapFields(["globalRefurbisher"]),
  },
  methods: {
    itemColor(item) {
      if (item.status === "Not Functional" || item.status === "Discovered") {
        return "green";
      } else if (
        item.status === "not received" ||
        item.status === "Not Received"
      ) {
        return "red";
      } else {
        return "grey";
      }
    },
    calDonationPrice(assets) {
      assets.forEach((asset) => {
        Math.round((this.donationPrice += parseFloat(asset.Value)));
      });
    },
  Asseticon(item) {
      if (item.status === "Not Functional") {
        this.ItemColor = "green";
        return "mdi-recycle";
      } else if (
        item.status === "not received" ||
        item.status === "Not Received"
      ) {
        this.ItemColor = "red";
        return "mdi-map-marker-question-outline";
      } else if (item.status === "Discovered") {
        this.ItemColor = "green";
        return "mdi-check-circle";
      } else {
        return "mdi-account-clock";
      }
    },
    dayElapsed(time) {
      return moment().diff(time, "days");
    },
    routeTo(asset) {
      window.open(
        "https://portal.techreuse.com/public/" + asset,
        "_blank"
      );
    },
    async getDonorDetail(donorID) {
      let donor = await fb.db.collection("donors").doc(donorID).get();
      this.donor = donor.data();
    },
    async getAssetsDetail() {
      let tempAssets = await fb.db
        .collection("assets")
        .where("donations", "==", this.$route.params.id)
        .where("refurbisher", "==", this.globalRefurbisher)
        .orderBy("assetTag")
        .get();
      this.assets = tempAssets.docs.map((item) => item.data());
      this.calDonationPrice(this.assets);
    },
  },
  async mounted() {
    let data = await fb.db
      .collection("donations")
      .doc(this.$route.params.id)
      .get();
    this.donation = data.data();
    this.getDonorDetail(this.donation.donor);
    this.getAssetsDetail();
  },
};
</script>